import 'string.prototype.includes'
import { HashRouter } from 'react-router-dom'
import { hot } from 'react-hot-loader/root'
import { Provider } from 'react-redux'

import Store from './store'
import FormContext from './form'
import Analytics from './analytics'
import Theme from './theme'
import Pages from './pages'
import Error from 'components/error';

import './font.css'

function App() {
  return (
    <Provider store={Store}>
      <Analytics>
        <HashRouter>
          <FormContext>
            <Theme>
              <Error>
                <Pages />
              </Error>
            </Theme>
          </FormContext>
        </HashRouter>
      </Analytics>
    </Provider>
  )
}

export default hot(App)
